<template>
  <div class='main'>
    <div class='menuContainer' :style="`width:${isHidden?'0':'221px'}`">
      <div class='hiddenIcon' @click='hiddenTab'>
        <i :class="isHidden?'el-icon-caret-right':'el-icon-caret-left'" style='color:#fff' />
      </div>
      <el-menu
        :default-active='pathActive'
        text-color='#335483'
        active-text-color='#fff'
        :unique-opened='true'
        style='width: 221px;height: 100%;overflow-y: auto;'
        :style="`transform:translateX(${isHidden?'-221px':'0'});transition: all .3s;`"
        @select='selectMenu'
        router
      >
        <!--        <el-submenu index="/financial/highway" v-has="'pc_price_manage'">-->
        <!--          <template slot="title">-->
        <!--            <i class="el-icon-s-order" style="color:#335483"/>-->
        <!--            <span>价格管理</span>-->
        <!--          </template>-->
        <!--          <el-menu-item-group v-has="'pc_high_way_price_manage'">-->
        <!--            <el-menu-item index="/financial/highway">公路价格管理</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--          <el-menu-item-group v-has="'pc_water_way_price_manage'">-->
        <!--            <el-menu-item index="/financial/waterway">水路价格管理</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--        </el-submenu>-->
        <!--        <el-submenu index="/financial/cars" v-has="'pc_settle_manage'">-->
        <!--          <template slot="title">-->
        <!--            <i class="el-icon-s-tools" style="color:#335483"/>-->
        <!--            <span>结算管理</span>-->
        <!--          </template>-->
        <!--          <el-menu-item-group v-has="'pc_fleet_settle'">-->
        <!--            <el-menu-item index="/financial/cars">车队结算</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--          <el-menu-item-group v-has="'pc_boat_settle'">-->
        <!--            <el-menu-item index="/financial/ships">船舶结算</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--          <el-menu-item-group v-has="'pc_load_price_manage'">-->
        <!--            <el-menu-item index="/financial/handings">装卸费管理</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--        </el-submenu>-->
        <!--        <el-submenu index="/financial/carp" v-has="'pc_pay_manage'">-->
        <!--          <template slot="title">-->
        <!--            <i class="el-icon-s-order" style="color:#335483"/>-->
        <!--            <span>支付管理</span>-->
        <!--          </template>-->
        <!--          <el-menu-item-group v-has="'pc_fleet_pay'">-->
        <!--            <el-menu-item index="/financial/carp">车队支付</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--          <el-menu-item-group v-has="'pc_boat_pay'">-->
        <!--            <el-menu-item index="/financial/shipp">船舶支付</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--          <el-menu-item-group v-has="'pc_load_price_pay'">-->
        <!--            <el-menu-item index="/financial/handingp">装卸费支付</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--        </el-submenu>-->
        <!--      </el-menu>-->

        <el-submenu index='/financial/income2'>
          <template slot='title' v-has="'pc_finance_supervise'">
            <i class='el-icon-s-finance' style='color:#335483' />
            <span>金融监管</span>
          </template>
          <el-menu-item-group v-has="'pc_finance_supervise_collect'">
            <el-menu-item index='/financial/income2'>收入挂账管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_finance_supervise_pay'">
            <el-menu-item index='/financial/expend'>支出挂账管理</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/financial/highway' v-has="'pc_income_price_manage'">
          <template slot='title' v-has="'pc_income_price_manage'">
            <i class='el-icon-wallet' style='color:#335483;font-weight: 700' />
            <span>收入价格设置</span>
          </template>
          <el-menu-item-group v-has="'pc_income_price_consignor_port'">
            <el-menu-item index='/financial/highway'>运输线路价格设置</el-menu-item>
          </el-menu-item-group>
<!--          <el-menu-item-group v-has="'pc_income_price_consignor_car'">-->
<!--            <el-menu-item index='/financial/entrustprice'>港口作业单价设置</el-menu-item>-->
<!--          </el-menu-item-group>-->
          <el-menu-item-group v-has="'pc_income_consignor_special'">
            <el-menu-item index='/financial/consignorSpecialPrice'>特殊情况价格设置</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_warehouse_and_others'">
            <el-menu-item index='/financial/harborWarehouseIncomePriceSetting'>库场及其他价格设置
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_income_plan_years'">
            <el-menu-item index='/financial/monthYearPlanRevenuePriceSetting'>年月计划价格设置
            </el-menu-item>
          </el-menu-item-group>
          <!-- <el-menu-item-group v-has="'pc_income_price_consignor_freight'">
            <el-menu-item index="/financial/mention">提车费单价设置</el-menu-item>
          </el-menu-item-group> -->

        </el-submenu>
        <el-submenu index='/financial/waterway' v-has="'pc_pay_price_manage'">
          <template slot='title' v-has="'pc_pay_price_manage'">
            <i class='el-icon-wallet' style='color:#335483;font-weight: 700' />
            <span>支出价格设置</span>
          </template>
          <el-menu-item-group v-has="'pc_pay_price_supplier_freight'">
            <el-menu-item index='/financial/waterway'>运输线路价格设置</el-menu-item>
          </el-menu-item-group>
<!--          <el-menu-item-group v-has="'pc_pay_price_supplier_port_task_intercept'">-->
<!--            <el-menu-item index='/financial/portWork'>港口作业费拦截</el-menu-item>-->
<!--          </el-menu-item-group>-->
          <el-menu-item-group v-has="'pc_pay_price_supplier_port'">
            <el-menu-item index='/financial/port'>港口装卸费</el-menu-item>
          </el-menu-item-group>
<!--          <el-menu-item-group v-has="'pc_pay_price_supplier_port_other'">-->
<!--            <el-menu-item index='/financial/porta'>港口其它费</el-menu-item>-->
<!--          </el-menu-item-group>-->
          <el-menu-item-group v-has="'pc_pay_price_port_stockpile'">
            <el-menu-item index='/financial/stockpiledPrice'>港口堆存费</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_pay_price_pick_up_fare'">
            <el-menu-item index='/financial/mention'>提车费</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_pay_price_supplier_special'">
            <el-menu-item index='/financial/supplierSpecialPrice'>特殊情况价格设置</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_pay_plan_years'">
            <el-menu-item index='/financial/monthlyMonthlyPlannedExpenditurePriceSetting'>年月计划价格设置</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_pay_warehouse_and_others'">
            <el-menu-item index='/financial/portWarehouseExpenditurePriceSetting'>库场及其他价格设置
            </el-menu-item>
          </el-menu-item-group>
          <!-- <el-menu-item-group v-has="'pc_pay_price_supplier_depository'">
            <el-menu-item index="/financial/warehouse">仓库价格管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_pay_price_supplier_labour'">
            <el-menu-item index="/financial/labor">劳务单价设置</el-menu-item>
          </el-menu-item-group> -->
        </el-submenu>
        <el-submenu index='/financial/other' v-has="'pc_other_price_manage'">
          <template slot='title' v-has="'pc_other_price_manage'">
            <i class='el-icon-wallet' style='color:#335483;font-weight: 700' />
            <span>其他价格设置</span>
          </template>
          <el-menu-item-group v-has="'pc_other_price_automatic_receipt_pay'">
            <el-menu-item index='/financial/other'>自动收/付款价格设置</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/financial/cars'>
          <template slot='title' v-has="'pc_consignor_collect'">
            <i class='el-icon-s-tools' style='color:#335483' />
            <span>委托商收款</span>
          </template>
          <el-menu-item-group v-has="'pc_consignor_collect_freight'">
            <el-menu-item index='/financial/cars'>托运费收款</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_consignor_port_task'">
            <el-menu-item index='/financial/ships'>港口费收款</el-menu-item>
          </el-menu-item-group>
          <!--<el-menu-item-group v-has="'pc_consignor_unknown_task'">
                      <el-menu-item index='/financial/handings'>未知费收款</el-menu-item>
                    </el-menu-item-group>-->
        </el-submenu>
        <el-submenu index='/financial/carp' v-has="'pc_supplier_pay'">
          <template slot='title'>
            <i class='el-icon-s-order' style='color:#335483' />
            <span>供应商付款</span>
          </template>
          <el-menu-item-group v-has="'pc_finance_confirm'">
            <el-menu-item index='/financial/financialConfirmation'>财务确认</el-menu-item>
          </el-menu-item-group>
          <!--          <el-menu-item-group v-has="'pc_supplier_pay_freight'">
                      <el-menu-item index='/financial/carp'>托运费付款</el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group v-has="'pc_supplier_pay_port_cost'">
                      <el-menu-item index='/financial/shipp'>港口费付款</el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group v-has="'pc_supplier_pay_port_pick_up_fare'">
                      <el-menu-item index='/financial/handingp'>库房费付款</el-menu-item>
                    </el-menu-item-group>-->
        </el-submenu>
        <el-submenu index='/financial/shipSettlement'>
          <template slot='title' v-has="'pc_ship_settlement'">
            <i class='el-icon-wallet' style='color:#335483' />
            <span>轮船结算</span>
          </template>
          <el-submenu index='/financial/commercialCarPrice'>
            <template slot='title' v-has="'pc_ship_settlement_river'">江运部分</template>
            <!--            <el-menu-item-group v-has="'pc_ship_settlement_river_general'">-->
            <!--              <el-menu-item index='/financial/commercialCarPrice'>商品车普价</el-menu-item>-->
            <!--            </el-menu-item-group>-->
            <el-menu-item-group v-has="'pc_ship_settlement_river_obvious'">
              <el-menu-item index='/financial/reconciliationDetails'>对账明细</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-has="'pc_ship_settlement_river_month'">
              <el-menu-item index='/financial/mothFreightVolumeReport'>月运量图表分析</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-has="'pc_ship_settlement_river_plan'">
              <el-menu-item index='/financial/commercialCarPlan'>商品车计划</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-has="'pc_ship_settlement_river_large_report'">
              <el-menu-item index='/financial/riverTransportationReport'>江运大报表</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index='/financial/yearAndMonthReport'>
            <template slot='title' v-has='"pc_ship_settlement_statistics"'>统计部分</template>
            <el-menu-item-group v-has="'pc_ship_settlement_statistics_monthly_report'">
              <el-menu-item index='/financial/yearAndMonthReport'>年月汇报表</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-has="'pc_ship_settlement_statistics_monthly_summary'">
              <el-menu-item index='/financial/yearAndMonthSummary'>年月汇总表</el-menu-item>
            </el-menu-item-group>
            <el-submenu index='/financial/dataDifferenceAnalysis'>
              <template slot='title' v-has="'pc_other_price_manage'">多版本差异分析</template>
              <el-menu-item-group v-has="'pc_ship_settlement_statistics_difference_analysis'">
                <el-menu-item index='/financial/dataDifferenceAnalysis/monthlyPlan'>年月计划</el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group v-has="'pc_ship_settlement_statistics_difference_analysis'">
                <el-menu-item index='/financial/dataDifferenceAnalysis/provisionalIncomeExpenditure'>暂估收支</el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group v-has="'pc_ship_settlement_statistics_difference_analysis'">
                <el-menu-item index='/financial/dataDifferenceAnalysis/preSettlementIncomeExpenditure'>预结算收支</el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group v-has="'pc_ship_settlement_statistics_difference_analysis'">
                <el-menu-item index='/financial/dataDifferenceAnalysis/warehouseAndOther'>库房及其他</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item-group v-has="'pc_ship_settlement_statistics_netasset_value'">
              <el-menu-item index='/financial/revenueAndExpenditureAndNetValue'>营业收支及资产净值
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-submenu>
        <el-submenu index='/financial/statistics' v-has="'pc_finance_report'">
          <template slot='title'>
            <i class='el-icon-s-order' style='color:#335483' />
            <span>财务报表</span>
          </template>
          <el-menu-item-group v-has="'pc_finance_report_payment'">
            <el-menu-item index='/financial/statistics'>收款/付款时间报表</el-menu-item>
          </el-menu-item-group>

        </el-submenu>
      </el-menu>
    </div>
    <div class='content2' :style="`width:${isHidden?'100%':'calc(100% - 221px)'}`"
         style='background-color: rgb(244, 247, 251);'>
      <router-view v-if="$route.path.split('/').length>=3" />
      <Home v-else />
      <div class='footer-div'>渝ICP备2022002327号-1</div>
    </div>
  </div>
</template>

<script>
  import Home from '@/views/home/main';

  export default {
    components: {
      Home,
    },

    data() {
      return {
        pathActive: null,
        activeNum: 1,
        isHidden: false,
      };
    },
    watch: {
      $route(to, from) {
        this.pathActive = this.$route.path;
      },
    },
    mounted() {
      this.pathActive = this.$route.path;
    },
    methods: {
      hiddenTab() {
        this.isHidden = !this.isHidden;
      },
      selectMenu() {
        this.activeNum = 0;
      },
    },
  };
</script>


<style lang='scss' scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;

    .menuContainer {
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
      position: relative;
      transition: all .3s;
      height: calc(100vh - 70px);
      overflow-x: hidden;

      .hiddenIcon {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #48599E;
        width: 11px;
        height: 50px;
        position: absolute;
        top: calc(50% - 20px);
        right: -11px;
        border-radius: 0 10px 10px 0;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .content {
      width: calc(100% - 221px);
      height: calc(100vh - 70px);
      overflow: auto;
    }

    .content2 {
      transition: all .3s;
      width: 100%;
      height: calc(100vh - 70px);
      overflow: auto;
    }

    ::v-deep {
      .el-menu-item.is-active {
        background-color: #335483;
      }

      .el-menu-item:focus {
        outline: 0;
        background-color: #335483;
      }
    }

    .content2 > .contract-list, .content2 > .electrify,
    .content2 > .operation, .content2 > .consignSettle,
    .content2 > .portSettle, .content2 > .stockpile,
    .content2 > .warehouse, .content2 > .deferlnvoicing,
    .content2 > .massLoss-list, .content2 > .logisticsConfig,
    .content2 > .finance-income, .content2 > .price-highway,
    .content2 > .main, .content2 > .supplierTrain,
    .content2 > .otherFees, .content2 > .mainContainer {
      height: calc(100% - 30px);
      overflow-y: auto;
    }

    .footer-div {
      display: block;
      position: relative;
      bottom: 0px;
      left: 0px;
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 13px;
      color: #a8a8a8;
      background-color: #f4f7fb;
    }
  }
</style>
